import { BaseFinancialItem, Liability } from 'src/financial/financial-data/hooks/useFinancialItems';
import { useState } from 'react';
import { Accordion } from '@mantine/core';
import { IconCoins } from '@tabler/icons-react';
import NetWorthTableSubCategorySection from 'src/financial/financial-data/net-worth-table/NetWorthTableSubCategorySection';
import { AccordionHeader } from 'src/financial/financial-data/net-worth/AccordionHeader';
import LiabilitiesTable from 'src/financial/financial-data/tables/LiabilitiesTable';
import { DynamicUiEntitiesMetadata } from 'src/UI/dynamicUI/types';
import { useCurrency } from 'src/common/hooks/useCurrency';

type LiabilitiesAccordionProps = {
  liabilities: Liability[];
  activeItem: string | null;
  onSubmit: () => void;
  metadata: DynamicUiEntitiesMetadata;
  onRowClick: (clickedItem: BaseFinancialItem) => void;
};
export const LiabilitiesAccordion = ({
  liabilities,
  activeItem,
  onSubmit,
  metadata,
  onRowClick,
}: LiabilitiesAccordionProps) => {
  const currency = useCurrency();
  const [selectedSection, setSelectedSection] = useState<string | null>(null);
  const accordionKey = 'LIABILITIES';
  const title = 'Liabilities';

  const productSections = [
    {
      displayName: 'Loans',
      id: 'loans',
      liabilities: liabilities.filter(a => a.product === 'Loan'),
    },
    {
      displayName: 'Mortgages',
      id: 'mortgages',
      liabilities: liabilities.filter(a => a.product === 'Mortgage'),
    },
  ];

  return (
    <Accordion.Item role="region" key={accordionKey} value={accordionKey}>
      <Accordion.Control>
        <AccordionHeader
          title={title}
          count={liabilities.length}
          amount={addLiabilities(liabilities)}
          currency={currency}
          Icon={IconCoins}
          isOpen={activeItem === accordionKey}
        />
      </Accordion.Control>
      <Accordion.Panel>
        {productSections.map(item => (
          <NetWorthTableSubCategorySection
            key={item.displayName}
            id={item.id}
            onClick={() =>
              setSelectedSection(item.displayName !== selectedSection ? item.displayName : null)
            }
            title={item.displayName}
            expanded={selectedSection === item.displayName}
            total={addLiabilities(item.liabilities)}
          >
            <LiabilitiesTable
              liabilities={item.liabilities}
              pl="xxs"
              titleParts={[title, item.displayName]}
              onSubmit={onSubmit}
              metadata={metadata}
              onRowClick={onRowClick}
            />
          </NetWorthTableSubCategorySection>
        ))}
      </Accordion.Panel>
    </Accordion.Item>
  );
};

export function addLiabilities(items: Liability[]) {
  return items.reduce((accumulator, i) => accumulator + i.remainingBalance, 0);
}
